module.exports = __webpack_public_path__ + "static/media/brainflix-combined-2-iphonex.f468f2ab.png";